import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { IconTooltipBadge } from '@ooh/ui/components/icon-tooltip-badge';

export interface ResolvedProfileCardProps {
  /** Card heading. Pass a translated string, e.g. t('availabilityImport.resolvedProfile.title'). */
  heading: string;
  helperText: string;
  badgeTone: 'success' | 'warning';
  badgeIcon: LucideIcon;
  /** Full confidence message shown in the badge's tooltip. */
  badgeText: string;
  children: ReactNode;
}

/**
 * Shell for the availability-import preview phase's "resolved profile" card:
 * heading + helper text on the left, a collapsed confidence badge on the
 * right (full message on hover/tap), and the profile's editable fields below.
 */
export function ResolvedProfileCard({
  heading,
  helperText,
  badgeTone,
  badgeIcon,
  badgeText,
  children,
}: ResolvedProfileCardProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-5 space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-[13px] font-semibold text-foreground">{heading}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{helperText}</p>
        </div>
        <IconTooltipBadge tone={badgeTone} icon={badgeIcon} text={badgeText} />
      </div>
      {children}
    </div>
  );
}
